<template>
    <CardView title="Project Output" ttyId="7" :filterControls="filterControls"></CardView>
</template>

<script>
    import CardView from '@/components/CardView.vue'
    export default {
        name: 'Project Output',
        components: {
            CardView
        },
        data() {
            return {
                filterControls: []// [{ matId: 848 }, { matId: 845 }]
            }
        },
    } 
</script>
<style scoped>
</style>
 